// @ts-nocheck
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Ouve mensagens do pwa-sw.js e navega dentro do SPA sem recarregar a página.
 *
 * Cenário: quando o usuário clica num push, o SW tenta `client.navigate(url)`.
 * Em alguns navegadores (notadamente iOS Safari) `client.navigate` falha ou
 * não atualiza o react-router; nesse caso o SW faz fallback para
 * `postMessage({ type: 'NAVIGATE', url })` e esse bridge finaliza o deep-link.
 */
export const PwaSwNavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

    const onMessage = (event: MessageEvent) => {
      const data = event.data;
      if (!data || data.type !== 'NAVIGATE' || typeof data.url !== 'string') return;
      try {
        const u = new URL(data.url, window.location.origin);
        navigate(u.pathname + u.search + u.hash, { replace: false });
      } catch {
        navigate(data.url, { replace: false });
      }
    };

    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [navigate]);

  return null;
};
